// extracted by mini-css-extract-plugin
export default {"bar":"Bar_bar__qlf4l"};